export const AGENT_NAMES = {
    h01_sales_analyst: { en: "Daily sales pack", ar: "تقرير المبيعات اليومي" },
    h02_weekly_pack: { en: "Weekly sales pack", ar: "تقرير المبيعات الأسبوعي" },
    h05_board_pack: { en: "Monthly board pack", ar: "تقرير مجلس الإدارة الشهري" },
    h03_kyc_gate: { en: "KYC case check", ar: "فحص ملف اعرف عميلك" },
    h06_marketing_gate: { en: "Marketing check", ar: "فحص المواد التسويقية" },
    h06_rewrite: { en: "Marketing rewrite", ar: "إعادة صياغة المادة التسويقية" },
    h07_digital_performance: { en: "Digital funnel report", ar: "تقرير المسار الرقمي" },
    h10_vendor_governance: { en: "Vendor SLA report", ar: "تقرير التزام الموردين" },
    a03_audit_report: { en: "Audit report", ar: "تقرير التدقيق" },
};
const humanise = (key) => {
    const s = key.replace(/[_.]+/g, " ").replace(/\s+/g, " ").trim();
    return s ? s.charAt(0).toUpperCase() + s.slice(1) : key;
};
export function agentName(key, lang) {
    return AGENT_NAMES[key]?.[lang] ?? humanise(key);
}
const DECISIONS = {
    approved: { verb: { en: "Approve", ar: "موافقة" }, past: { en: "approved", ar: "تمت الموافقة" } },
    rejected: { verb: { en: "Reject", ar: "رفض" }, past: { en: "rejected", ar: "رُفض" } },
    needs_more_info: { verb: { en: "Ask for more", ar: "طلب المزيد" }, past: { en: "asked for more", ar: "طُلب المزيد" } },
};
export function decisionWord(d, form, lang) {
    return DECISIONS[d]?.[form][lang] ?? humanise(d);
}
export const FIELD_WORDS = {
    anomaly_count: { en: "anomalies", ar: "الحالات غير الاعتيادية" },
    wow_gross_pct: { en: "week-on-week gross change", ar: "تغيّر الإجمالي أسبوعياً" },
    period_change_pct: { en: "change against the period before", ar: "التغيّر مقارنة بالفترة السابقة" },
    breach_count: { en: "breaches", ar: "المخالفات" },
    vendors_in_breach: { en: "vendors in breach", ar: "الموردون المخالفون" },
    drop_found: { en: "a funnel drop", ar: "انخفاض في المسار" },
    gross_aed_total: { en: "gross", ar: "الإجمالي" },
    net_inflow_aed: { en: "net inflow", ar: "صافي التدفق" },
    txn_count: { en: "transactions", ar: "المعاملات" },
    attainment_pct: { en: "SLA attainment", ar: "نسبة الالتزام" },
    forbidden_phrases_found: { en: "forbidden phrases", ar: "عبارات محظورة" },
    attached_statements: { en: "statements attached", ar: "البيانات المرفقة" },
    mean_window: { en: "trailing mean", ar: "المتوسط السابق" },
    window_days: { en: "look-back days", ar: "أيام المقارنة" },
};
export function fieldWord(key, lang) {
    return FIELD_WORDS[key]?.[lang] ?? humanise(key).toLowerCase();
}
/** The book's channels, by code. */
export const CHANNEL_WORDS = {
    APP: { en: "Mobile app", ar: "التطبيق" },
    WEB: { en: "Website", ar: "الموقع الإلكتروني" },
    RM: { en: "Relationship managers", ar: "مديرو العلاقات" },
    DSF: { en: "Direct sales", ar: "المبيعات المباشرة" },
    XH1: { en: "Al Ansari Exchange", ar: "الأنصاري للصرافة" },
    XH2: { en: "Al Fardan Exchange", ar: "الفردان للصرافة" },
    XH3: { en: "Wall Street Exchange", ar: "وول ستريت للصرافة" },
    XH4: { en: "Al Rostamani Exchange", ar: "الرستماني للصرافة" },
    XH5: { en: "Orient Exchange", ar: "أورينت للصرافة" },
    XH6: { en: "Redha Al Ansari Exchange", ar: "رضا الأنصاري للصرافة" },
    EPO: { en: "Post offices", ar: "مكاتب البريد" },
    BK1: { en: "Partner bank (Islamic)", ar: "البنك الشريك (إسلامي)" },
    BK2: { en: "Partner bank", ar: "البنك الشريك" },
    CRP: { en: "Corporate desk", ar: "مكتب الشركات" },
};
export function channelWord(code, lang) {
    return CHANNEL_WORDS[code]?.[lang] ?? code;
}
/** "XH1.gross_aed" → "Al Ansari Exchange gross". */
export function seriesWord(series, lang) {
    const [code, field] = series.split(".");
    if (!code || !field)
        return series;
    return `${channelWord(code, lang)} ${fieldWord(field.replace(/_aed$/, ""), lang)}`.trim();
}
const DAYS = [
    { en: "Sunday", ar: "الأحد" }, { en: "Monday", ar: "الاثنين" }, { en: "Tuesday", ar: "الثلاثاء" },
    { en: "Wednesday", ar: "الأربعاء" }, { en: "Thursday", ar: "الخميس" }, { en: "Friday", ar: "الجمعة" },
    { en: "Saturday", ar: "السبت" },
];
const ord = (n) => (n % 10 === 1 && n !== 11 ? "st" : n % 10 === 2 && n !== 12 ? "nd" : n % 10 === 3 && n !== 13 ? "rd" : "th");
/** A five-field cron line as a sentence; anything unusual is "On a schedule". */
export function cronInWords(cron, lang) {
    const parts = cron.trim().split(/\s+/);
    const fallback = lang === "ar" ? "وفق جدول" : "On a schedule";
    if (parts.length !== 5)
        return fallback;
    const [mi, h, dom, mon, dow] = parts;
    if (!/^\d+$/.test(mi) || !/^\d+$/.test(h) || mon !== "*")
        return fallback;
    const at = `${h.padStart(2, "0")}:${mi.padStart(2, "0")}`;
    if (dom === "*" && dow === "*")
        return lang === "ar" ? `يومياً عند ${at}` : `Every day at ${at}`;
    if (dom === "*" && /^[0-6]$/.test(dow)) {
        const d = DAYS[Number(dow)];
        return lang === "ar" ? `كل ${d.ar} عند ${at}` : `Every ${d.en} at ${at}`;
    }
    if (/^\d+$/.test(dom) && dow === "*") {
        const n = Number(dom);
        return lang === "ar" ? `في اليوم ${n} من كل شهر عند ${at}` : `On the ${n}${ord(n)} of each month at ${at}`;
    }
    return fallback;
}
/** Source tables a Hand reads, as a person names the data in them. */
const DATA_WORDS = {
    nb_sales_daily: { en: "sales data", ar: "بيانات المبيعات" },
    nb_products: { en: "the product list", ar: "قائمة المنتجات" },
    nb_digital_daily: { en: "app and web data", ar: "بيانات التطبيق والموقع" },
    nb_vendors: { en: "the vendor list", ar: "قائمة الموردين" },
    nb_vendor_slas: { en: "the vendors' contract terms", ar: "شروط عقود الموردين" },
    nb_vendor_tickets: { en: "vendor tickets", ar: "تذاكر الموردين" },
};
/** What a stopped run is waiting for, in a sentence. */
export function inputWord(raw, lang) {
    // Data that did not arrive (HandModule.missingData): "nb_sales_daily rows for 2026-09-29".
    const data = raw.match(/^(nb_[a-z_]+)(?: rows for (\S+))?$/);
    if (data) {
        const table = data[1];
        const what = DATA_WORDS[table]?.[lang] ?? humanise(table.slice(3)).toLowerCase();
        const when = data[2]?.replace("..", lang === "ar" ? " إلى " : " to ");
        if (lang === "ar")
            return when ? `${what} عن ${when} (لم تُحمَّل بعد)` : `${what} (لم يُحمَّل شيء)`;
        return when ? `${what} for ${when} (not loaded yet)` : `${what} (nothing loaded)`;
    }
    if (/^regulatory_rules/.test(raw)) {
        return lang === "ar" ? "القواعد لهذا التاريخ، إذ لم تستجب خدمة القواعد" : "the rules for that date, because the rules service didn't answer";
    }
    if (raw === "regulatory_determination") {
        return lang === "ar" ? "فحص القواعد، إذ لم تستجب خدمة القواعد" : "the rules check, because the rules service didn't answer";
    }
    if (/^[A-Z]{2,4}-\d+$/.test(raw))
        return lang === "ar" ? `إجابة للقاعدة ${raw}` : `an answer for rule ${raw}`;
    return humanise(raw).toLowerCase();
}
/** A rule's citation as a person reads it; a placeholder is never shown as policy. */
export function citationWords(r, lang) {
    const c = r.citation ?? "";
    if (r.origin === "placeholder" || /^placeholder\b/i.test(c)) {
        return lang === "ar" ? "قاعدة مؤقتة (ليست سياسة بعد)" : "Placeholder rule (not yet policy)";
    }
    return c;
}
